import React, {useState} from "react";
import {useSelector} from "react-redux";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {syncEmpowermentAsync} from "../../../../app/store/reducers/roaming/roamingEmpowermentReducer";
import IconButton from "../../../common/IconButton";
import PropTypes from "prop-types";

const SyncEmpowerment = ({id, ...props}) => {
    const lang = useSelector(selectLang);
    const t = Translate;

    const [loading, setLoading] = useState(false);
    const syncEmpowerment = () => {
        setLoading(true);
        syncEmpowermentAsync(id)
            .then()
            .catch()
            .finally(() => setLoading(false))
    };

    return (
        <IconButton
            icon={'fa-refresh'}
            variant="falcon-primary"
            onClick={syncEmpowerment}
            size="sm"
            iconClassName="me-1"
            disabled={loading}
            {...props}>
            {t(lang, "roaming.empowerment.sync")}
        </IconButton>
    )
};

SyncEmpowerment.propTypes = {
    id: PropTypes.string
}

SyncEmpowerment.defaulProps = {
    id: ""
}

export default SyncEmpowerment;